// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);

  var variant    = evt.detail.variant;
  var colorValue = getSelectedColor();

  if (!colorValue && variant && variant.options) {
    colorValue = variant.options[0];
  }

  updateProductTitle(colorValue);
  updateSmartDescription(variant);

  // Remove ?color and ?hardware from URL when user manually selects a variant
  var params = new URLSearchParams(window.location.search);
  if (params.has('color') || params.has('hardware')) {
    params.delete('color');
    params.delete('hardware');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', cleanUrl);
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ── Append selected Color variant to product title ───────────────────────
function getSelectedColor() {
  var selects = document.querySelectorAll('[name^="options["]');
  for (var i = 0; i < selects.length; i++) {
    var name = selects[i].name.replace('options[', '').replace(']', '').toLowerCase();
    if (name === 'color') return selects[i].value;
  }
  var labels = document.querySelectorAll('.product__label');
  for (var j = 0; j < labels.length; j++) {
    if (labels[j].textContent.toLowerCase().includes('color')) {
      var valueSpan = labels[j].querySelector('[data-selected-value-for-option]');
      if (valueSpan) return valueSpan.textContent.trim();
    }
  }
  return null;
}

function updateProductTitle(colorValue) {
  var titleEl = document.querySelector('.product__title');
  if (!titleEl) return;

  if (!titleEl.dataset.baseTitle) {
    titleEl.dataset.baseTitle = titleEl.textContent.trim();
  }

  titleEl.textContent = colorValue
    ? titleEl.dataset.baseTitle + ' ' + colorValue
    : titleEl.dataset.baseTitle;
}


// ── Smart description: variant_description > series_description ──────────
// Reads all variant descriptions from the embedded JSON script tag on page load.
// On variant change, looks up the new variant ID in the JSON and updates
// the description element. Falls back to series_description if no variant
// description exists. Hides the block if both are empty.
// ─────────────────────────────────────────────────────────────────────────
function updateSmartDescription(variant) {
  var descEl  = document.getElementById('product-smart-description');
  var dataEl  = document.getElementById('variant-descriptions-data');
  if (!descEl || !dataEl || !variant) return;

  var data = {};
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variantDesc     = data.variants && data.variants[String(variant.id)] ? data.variants[String(variant.id)] : '';
  var seriesDesc      = data.series_description || '';
  var wrapper         = descEl.closest('.product__description');
  var hasColorVariant = descEl.dataset.hasColorVariant === 'true';
  var displayDesc     = '';

  if (hasColorVariant) {
    displayDesc = variantDesc || seriesDesc;
  } else {
    displayDesc = seriesDesc;
  }

  if (displayDesc) {
    descEl.innerHTML = displayDesc;
    if (wrapper) wrapper.style.display = '';
  } else {
    if (wrapper) wrapper.style.display = 'none';
  }
}

// ── URL parameter variant pre-selection ──────────────────────────────────
// Usage: ?color=Yellow&hardware=Gold
// Waits for window load + 300ms so the theme's swatch click handlers are
// fully attached, then clicks the matching swatch button directly.
// No page reload — uses history.replaceState to clean up params after.
// ─────────────────────────────────────────────────────────────────────────
window.addEventListener('load', function () {
  var params        = new URLSearchParams(window.location.search);
  var colorParam    = params.get('color');
  var hardwareParam = params.get('hardware');

  if (!colorParam && !hardwareParam) {
    updateProductTitle(getSelectedColor());
    return;
  }

  // Wait for theme swatch handlers to be fully attached
  setTimeout(function () {

    if (colorParam) {
      document.querySelectorAll('[data-option-value]').forEach(function (btn) {
        if (btn.getAttribute('data-option-value').toLowerCase() === colorParam.toLowerCase()) {
          btn.click();
        }
      });
    }

    if (hardwareParam) {
      document.querySelectorAll('[data-option-value]').forEach(function (btn) {
        if (btn.getAttribute('data-option-value').toLowerCase() === hardwareParam.toLowerCase()) {
          btn.click();
        }
      });
    }

    // Clean up color/hardware from URL without reload
    params.delete('color');
    params.delete('hardware');
    var cleanUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', cleanUrl);

    setTimeout(function () {
      updateProductTitle(getSelectedColor());
    }, 100);

  }, 300);
});


// Color filter title prefix — runs on collection pages only
(function() {
  if (!window.location.pathname.includes('/collections/')) return;

  var params = new URLSearchParams(window.location.search);
  var colors = params.getAll('filter.p.m.custom.color');
  if (!colors.length) return;

  var colorLabel = colors.map(function(c) {
    return c.charAt(0).toUpperCase() + c.slice(1).toLowerCase();
  }).join(' & ');

  // Encodes plain text to match HTML entity format inside innerHTML
  function htmlEncode(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function applyColorTitle() {
    var collectionTitle = '';

    // 1. Update the collection banner h1
    var h1Selectors = [
      '.collection-banner__text-container-heading',
      '.main-collection-banner h1',
      'h1.section-blocks__heading'
    ];
    for (var i = 0; i < h1Selectors.length; i++) {
      var h1 = document.querySelector(h1Selectors[i]);
      if (h1 && !h1.dataset.colorPrefixed) {
        h1.dataset.colorPrefixed = '1';
        collectionTitle = h1.textContent.trim(); // "Handbags & clutches"
        h1.textContent = colorLabel + ' ' + collectionTitle;
        break;
      }
    }

    // Fallback: get collection title from og:title meta tag
    if (!collectionTitle) {
      var ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) collectionTitle = ogTitle.getAttribute('content').trim();
    }

    if (!collectionTitle) return;

    // 2. Update rich-text h2
    // Must encode title to match &amp; entities inside innerHTML
    var encodedTitle = htmlEncode(collectionTitle);
    var encodedColorLabel = htmlEncode(colorLabel);

    document.querySelectorAll('.rich-text__heading').forEach(function(h2) {
      if (!h2.dataset.colorPrefixed && h2.innerHTML.indexOf(encodedTitle) !== -1) {
        h2.dataset.colorPrefixed = '1';
        h2.innerHTML = h2.innerHTML.replace(
          encodedTitle,
          encodedColorLabel + ' ' + encodedTitle
        );
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyColorTitle);
  } else {
    applyColorTitle();
  }
})();

// Close nav dropdown when same-page anchor links are clicked inside the menu
(function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    // Only act on links inside the navigation
    if (!link.closest('.header__links-list') && !link.closest('.meganav')) return;

    var href = link.getAttribute('href') || '';
    var hash = href.split('#')[1];

    // Must be a same-page anchor (has a hash and the target element exists on this page)
    if (!hash || !document.getElementById(hash)) return;

    // Simulate a click on the body — triggers the theme's handleClick → closeAll()
    setTimeout(function() {
      document.body.click();
    }, 50);
  });
})();
